import { POLICY_BLOCKS } from "@/lib/mockData";
import SectionHeading from "@/components/SectionHeading";
import SectionReveal from "@/components/SectionReveal";
import OrganicShapes from "@/components/OrganicShapes";

export default function Privacy() {
    return (
        <main data-testid="privacy-page" className="bg-white pt-32 pb-24 relative overflow-hidden">
            <OrganicShapes variant="blue" />
            <section className="max-w-4xl mx-auto px-6 md:px-10 relative">
                <SectionHeading
                    eyebrow="Privacy Policy"
                    heading={["How we handle", "donor and record data."]}
                    italicIndex={1}
                    description="A plain-language summary of what we collect, why we collect it, and how it's used. Replace with your formal policy whenever ready."
                />

                <div className="mt-16 space-y-8">
                    {POLICY_BLOCKS.privacy.map((b, i) => (
                        <SectionReveal delay={i * 0.05} key={b.heading}>
                            <article className="card-base bg-seedh-surface-beige/40 p-7" data-testid={`privacy-block-${i}`}>
                                <div className="text-[0.65rem] tracking-[0.24em] uppercase text-seedh-brown font-semibold">
                                    Section {String(i + 1).padStart(2, "0")}
                                </div>
                                <h2 className="font-display text-2xl text-seedh-blue mt-2 leading-tight">
                                    {b.heading}
                                </h2>
                                <p className="text-base text-seedh-text mt-3 leading-relaxed">
                                    {b.body}
                                </p>
                            </article>
                        </SectionReveal>
                    ))}
                </div>

                <SectionReveal delay={0.2}>
                    <p className="mt-12 text-xs text-seedh-muted leading-relaxed">
                        Last updated · February 2026 · Placeholder content. Final
                        policy text can be added before production launch.
                    </p>
                </SectionReveal>
            </section>
        </main>
    );
}
